import React, { useEffect } from "react";
import icon_close from "../assets/icon_close.svg";


type Props = {
	setModalVersicherungOpen: (b: boolean) => void;
};
function RechnerModal(props: Props) {
	const { setModalVersicherungOpen } = props;


	return (
		<div className="Rechner-Modal">
			<div
				className="Rechner-Modal-Closer"
				onClick={() => setModalVersicherungOpen(false)}
				onKeyDown={(e) => e.key === "escape" && setModalVersicherungOpen(false)}
			/>
			<div className="Rechner-Modal-Content">
				<button
					className="Rechner-Modal-Close"
					onClick={() => setModalVersicherungOpen(false)}
					onKeyDown={(e) =>
						e.key === "escape" && setModalVersicherungOpen(false)
					}
					type="button"
				>
					<img
						src={icon_close}
						width={24}
						height={24}
						alt="Fenster Schliessen"
					/>
				</button>
				<div className="flex flex-col">

					<iframe src='/content/Versicherung_Weitere_Infos.pdf '  width="100%" height="1500"></iframe>
				</div>
			</div>
		</div>
	);
}
export default RechnerModal;